import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  pageData: {},
  pageFlag: 'create'
}

export const socialTagSlice = createSlice({
  name: 'socialTag',
  initialState,
  reducers: {
    // 自动生成 action creator 和 reducer
    setSocialTagDataAction: (state, action) => {
      state.pageData = action.payload
    },
    setSocialTagPageFlagAction: (state, action) => {
      state.pageFlag = action.payload
    },
  }
})

// 自动生成的 action creators
export const { setSocialTagDataAction, setSocialTagPageFlagAction } = socialTagSlice.actions


// Selectors
export const selectSocialTagData = (state) => state.socialTag.pageData
export const selectSocialTagPageFlag = (state) => state.socialTag.pageFlag

// Reducer
export default socialTagSlice.reducer